import React from "react";
import PropTypes from "prop-types";

import "./Home.css";
import SearchBar from "components/shared/SearchBar/SearchBar";
import HomePage from "components/Home/HomePage";
import tc_logo from "images/custom/logo_home.png";

import { ENABLE_HOME_SEARCH } from "config";

import lang from "lang";

const propTypes = {
  handleSearchChange: PropTypes.func.isRequired,
};

class CustomHomePage extends HomePage {
  /**
   * Render Logo
   */
  renderHomeLogo() {
    return (
      <div className="home-logo-container">
        <img className="imgresponsive" src={tc_logo} alt="Team Comply" />
      </div>
    );
  }

  /**
   * Render Home Buttons
   */
  renderHomeButtons() {
    return (
      <div className="home-buttons">
        {this.renderFeaturedGamesButton()}
        {this.renderMyGamesButton()}
        {this.renderBottomButtons()}
      </div>
    );
  }

  /**
   * Renders the Component
   */
  render() {
    return (
      <div className="home container">
        <div className="innerblock pure-g textcenter">
          <div className="pure-u-1 pure-u-sm-16-24 automargin">
            {ENABLE_HOME_SEARCH && (
              <SearchBar
                handleSearchChange={this.props.handleSearchChange}
                handleKeyPress={this.props.handleKeyPress}
                handleSubmit={this.props.handleSubmit}
                placeholder={lang.gametize_project_search_placeholder}
              />
            )}

            {this.renderHomeLogo()}
            {this.renderHomeButtons()}
          </div>
        </div>
      </div>
    );
  }
}

CustomHomePage.propTypes = propTypes;

export default CustomHomePage;
